import * as React from "react";

export const AssessmentsIcon: React.FC = () => (
  <svg
    data-testid="assesssments-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22.6367 11.3142V12.2342C22.6355 14.3907 21.9372 16.4889 20.6461 18.2161C19.3549 19.9432 17.54 21.2067 15.4721 21.8181C13.4041 22.4296 11.194 22.3561 9.17119 21.6088C7.1484 20.8615 5.42137 19.4803 4.24768 17.6713C3.07399 15.8623 2.51651 13.7223 2.6584 11.5706C2.80028 9.4188 3.63393 7.37057 5.035 5.73131C6.43607 4.09206 8.3295 2.94962 10.4329 2.47439C12.5363 1.99915 14.737 2.21658 16.7067 3.09424"
      stroke="#21394F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.6367 4.23438L12.6367 14.2444L9.63672 11.2444"
      stroke="#21394F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CourseCompletionIcon: React.FC = () => (
  <svg
    data-testid="course-completion-icon"
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0003 19.9997C21.155 19.9997 25.3337 15.821 25.3337 10.6663C25.3337 5.51168 21.155 1.33301 16.0003 1.33301C10.8457 1.33301 6.66699 5.51168 6.66699 10.6663C6.66699 15.821 10.8457 19.9997 16.0003 19.9997Z"
      stroke="#21394F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9463 18.5202L9.33301 30.6668L15.9997 26.6668L22.6663 30.6668L21.053 18.5068"
      stroke="#21394F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TopicsIcon: React.FC = () => (
  <svg
    data-testid="topics-icon"
    width="24"
    height="24"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33301 26.5492C5.33301 25.6651 5.6842 24.8173 6.30932 24.1921C6.93444 23.567 7.78229 23.2158 8.66634 23.2158H26.6663"
      stroke="#21394F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.66634 3.21582H26.6663V29.8825H8.66634C7.78229 29.8825 6.93444 29.5313 6.30932 28.9062C5.6842 28.2811 5.33301 27.4332 5.33301 26.5492V6.54915C5.33301 5.6651 5.6842 4.81725 6.30932 4.19213C6.93444 3.56701 7.78229 3.21582 8.66634 3.21582V3.21582Z"
      stroke="#21394F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UnitsIcon: React.FC = () => (
  <svg
    data-testid="units-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path d="M10.667 24H28.0003" stroke="#21394F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 24H4.01333" stroke="#21394F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.667 16H28.0003" stroke="#21394F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 16H4.01333" stroke="#21394F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.667 8H28.0003" stroke="#21394F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 8H4.01333" stroke="#21394F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const TimeTakenIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.0003 29.4323C23.3641 29.4323 29.3337 23.4628 29.3337 16.099C29.3337 8.73516 23.3641 2.76562 16.0003 2.76562C8.63653 2.76562 2.66699 8.73516 2.66699 16.099C2.66699 23.4628 8.63653 29.4323 16.0003 29.4323Z"
      stroke="#21394F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 8.09863V16.0986L21.3333 18.7653"
      stroke="#21394F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReinforcementIcon: React.FC<{ rotate: boolean }> = props => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={props.rotate ? { transform: "rotateX(180deg) rotateY(180deg)" } : undefined}
  >
    <path
      d="M5.71613 17.2478L3.58017 17.2478C3.12741 17.2558 2.68747 17.0973 2.34386 16.8023C2.00025 16.5074 1.7769 16.0965 1.7162 15.6478L1.7162 10.0479C1.7769 9.59914 2.00025 9.18831 2.34386 8.89337C2.68747 8.59842 3.12741 8.43991 3.58017 8.44792L5.71613 8.44792M11.316 6.84795L11.316 3.648C11.316 3.0115 11.0632 2.40106 10.6131 1.95098C10.163 1.5009 9.55258 1.24805 8.91607 1.24805L5.71613 8.44792L5.71613 17.2478L14.74 17.2478C15.1258 17.2521 15.5003 17.1169 15.7943 16.867C16.0883 16.6171 16.2821 16.2693 16.3399 15.8878L17.4439 8.68791C17.4787 8.4586 17.4633 8.22447 17.3986 8.00173C17.3339 7.77899 17.2216 7.57297 17.0694 7.39795C16.9172 7.22293 16.7288 7.08309 16.5172 6.98812C16.3056 6.89315 16.0759 6.84532 15.8439 6.84795L11.316 6.84795Z"
      stroke="#21394F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LanguageIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 25 21" fill="none">
    <path
      d="M8.57565 9.33284C8.41059 8.76222 8.20781 7.76718 8.20781 7.76718H8.18423C8.18423 7.76718 7.98145 8.76222 7.8164 9.33284L7.29294 11.1013H9.08967L8.57565 9.33284ZM4.18049 14.044L6.89209 6.06948C6.97226 5.83841 7.18448 5.6875 7.4297 5.6875H8.96234C9.20285 5.6875 9.41978 5.84312 9.49995 6.06948L12.2116 14.044C12.3342 14.4118 12.0654 14.7938 11.6739 14.7938H10.594C10.472 14.7937 10.3532 14.7542 10.2555 14.6811C10.1578 14.608 10.0863 14.5053 10.0517 14.3882L9.60841 12.8839H6.76948L6.34034 14.3835C6.2696 14.624 6.04796 14.7938 5.79802 14.7938H4.71809C4.3314 14.7938 4.05788 14.4118 4.18049 14.044Z"
      fill="#21394F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.09625 16.3249L6.19802 17.7132V16.3249L14.2031 16.3249L14.2031 3.95559L1.91866 3.95559C1.87765 3.95559 1.85519 3.97031 1.84623 3.97883C1.84567 3.97935 1.84518 3.97985 1.84475 3.9803L1.84475 16.3002C1.84518 16.3006 1.84567 16.3011 1.84623 16.3017C1.85519 16.3102 1.87765 16.3249 1.91866 16.3249H5.09625ZM1.91866 2.88477C1.28429 2.88477 0.773927 3.36997 0.773927 3.97309L0.773926 16.3074C0.773926 16.9105 1.28429 17.3957 1.91866 17.3957H4.57901L6.63231 19.983C6.84249 20.2478 7.26884 20.0992 7.26884 19.7611V17.3957L15.2739 17.3957L15.2739 2.88477L1.91866 2.88477Z"
      fill="#21394F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8579 0.882812H23.8341C24.3554 0.882812 24.7749 1.29869 24.7749 1.81563V12.3876C24.7749 12.9045 24.3554 13.3204 23.8341 13.3204H21.9077L19.9919 15.7142C19.6966 16.0832 19.1015 15.8744 19.1015 15.4018V13.3204H12.8579V0.882812ZM22.4229 6.01331C22.6816 6.01331 22.8933 5.80342 22.8933 5.5469V4.92502C22.8933 4.6685 22.6816 4.45861 22.4229 4.45861H19.914V3.83673C19.914 3.58021 19.7023 3.37033 19.4436 3.37033H18.8164C18.5577 3.37033 18.346 3.58021 18.346 3.83673V4.45861H15.8372C15.5784 4.45861 15.3667 4.6685 15.3667 4.92502V5.5469C15.3667 5.80342 15.5784 6.01331 15.8372 6.01331H20.3178C20.0747 6.56911 19.671 7.14046 19.1418 7.69238C18.883 7.4242 18.6557 7.15212 18.4597 6.88005C18.3186 6.68183 18.0441 6.62353 17.8325 6.7479L17.5463 6.91503L17.2915 7.06662C17.0602 7.20265 16.9897 7.5097 17.1465 7.73125C17.3856 8.06939 17.66 8.40365 17.9697 8.73014C17.6521 8.975 17.3111 9.20821 16.9465 9.42975C16.727 9.5619 16.6564 9.84175 16.7819 10.0594L17.0916 10.5997C17.2249 10.829 17.5189 10.9028 17.7462 10.7668C18.2441 10.4636 18.7066 10.1371 19.1339 9.79899C19.5612 10.141 20.0277 10.4636 20.5216 10.7668C20.749 10.9028 21.043 10.829 21.1763 10.5997L21.486 10.0594C21.6114 9.83786 21.5408 9.5619 21.3252 9.42975C20.9724 9.21598 20.6314 8.97889 20.3021 8.73014C21.1253 7.85562 21.7055 6.93058 21.976 6.01331H22.4229Z"
      fill="#21394F"
    />
  </svg>
);

export const SortAscendingIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
    <title>sort-ascending</title>
    <path d="M5.5 0.507813L10.2631 5.75782L0.736859 5.75781L5.5 0.507813Z" fill="currentColor" />
  </svg>
);

export const SortDescendingIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
    <title>sort-descending</title>
    <path d="M5.5 5.50781L0.736861 0.257812L10.2631 0.257812L5.5 5.50781Z" fill="currentColor" />
  </svg>
);
